import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import MaintenanceTemplatesEditor from '../Förvaltning/TemplatesEditor/MaintenanceTemplatesEditor';
import BuildingCheckTemplatesEditor from '../BuildingChecks/BuildingCheckTemplatesEditor';
import ManageUsers from './ManageUsers';
import LocationCategoriesManagementPage from './LocationCategoriesManagementPage';
import LoginPageSettings from './LoginPageSettings';
import './SettingsPage.css';

const SettingsPage = () => {
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState<'general' | 'location-categories' | 'maintenance-templates' | 'building-checks' | 'manage-users'>('general');

    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab === 'building-checks') {
            setActiveTab('building-checks');
        } else if (tab === 'maintenance-templates') {
            setActiveTab('maintenance-templates');
        } else if (tab === 'manage-users') {
            setActiveTab('manage-users');
        } else if (tab === 'location-categories') {
            setActiveTab('location-categories');
        }
    }, [searchParams]);

    return (
        <div className="settings-page">
            <Helmet>
                <title>Inställningar - Molnfastigheter</title>
            </Helmet>
            
            <Navbar bg="light" expand="lg" className="settings-navbar">
                <Container fluid>
                    <Navbar.Brand className="settings-brand">
                        <h1 className="settings-title">Inställningar</h1>
                        <p className="settings-description">Hantera systeminställningar och konfiguration</p>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link 
                                className={`settings-nav-link ${activeTab === 'general' ? 'active' : ''}`}
                                onClick={() => setActiveTab('general')}
                            >
                                Allmänt
                            </Nav.Link>
                            <Nav.Link 
                                className={`settings-nav-link ${activeTab === 'location-categories' ? 'active' : ''}`}
                                onClick={() => setActiveTab('location-categories')}
                            >
                                Platskategorier
                            </Nav.Link>
                            <Nav.Link 
                                className={`settings-nav-link ${activeTab === 'maintenance-templates' ? 'active' : ''}`}
                                onClick={() => setActiveTab('maintenance-templates')}
                            >
                                Underhållsmallar
                            </Nav.Link>
                            <Nav.Link 
                                className={`settings-nav-link ${activeTab === 'building-checks' ? 'active' : ''}`}
                                onClick={() => setActiveTab('building-checks')}
                            >
                                Kontrollmallar
                            </Nav.Link>
                            <Nav.Link 
                                className={`settings-nav-link ${activeTab === 'manage-users' ? 'active' : ''}`}
                                onClick={() => setActiveTab('manage-users')}
                            >
                                Hantera användare
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <div className="settings-content">
                <Container fluid>
                    {activeTab === 'general' && (
                        <LoginPageSettings />
                    )}
                    {activeTab === 'location-categories' && (
                        <LocationCategoriesManagementPage />
                    )}
                    {activeTab === 'maintenance-templates' && (
                        <MaintenanceTemplatesEditor />
                    )}
                    {activeTab === 'building-checks' && (
                        <BuildingCheckTemplatesEditor />
                    )}
                    {activeTab === 'manage-users' && (
                        <ManageUsers />
                    )}
                </Container>
            </div>
        </div>
    );
};

export default SettingsPage;
